import dateUtiilsInterface from "./dateUtilsInterface";

export default class dateUtilsImpl implements dateUtiilsInterface {

    public static formatDate(date) {
        return new Date(date).toLocaleDateString('default', { month: 'long', day: "numeric", year: "numeric" });
    }
    
}